import Link from 'next/link'
import React, { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { TitleH2Styledv2, SubText } from '../Typography'
import Image from 'next/image'
import LinkButton from 'components/LinkButton'
import { CDN_URL } from 'config/site'

const BannerSec2: FC<{
  bannerimg: string
  subTitle: string
  title: string
  blueTitle: string
  blueTitle2: string
  btnText1: string
  btnText2: string
  btnLink: string
  altTag: string
}> = ({
  blueTitle,
  blueTitle2,
  title,
  subTitle,
  bannerimg,
  btnText1,
  btnText2,
  btnLink,
  altTag,
}) => {
  return (
    <section className="banner_inner d-flex flex-column justify-content-center">
      <Container className="position-relative">
        <Row className="align-items-center">
          <Col lg={7} className="banner_inner_left">
            <TitleH2Styledv2
              className="mb-4 pe-0 pe-xxl-5 me-0 me-xxl-5"
              text={title}
              blueTitle={blueTitle}
              blueTitle2={blueTitle2}
            />
            <SubText
              className="mb-2 pt-2 pe-0 pe-xl-5 me-0 me-lg-5 text_para_large"
              text={subTitle}
            />
            <div className="mt-3 mt-lg-4 mb-0">
              <LinkButton path={btnLink}>
                {btnText1} {btnText2}
              </LinkButton>
            </div>
          </Col>
          <Col lg={5} className="banner_inner_icon">
            <img
              // Plain <img> skips the next/image CDN loader: prefix site paths
              src={bannerimg?.startsWith('/') ? `${CDN_URL}${bannerimg}` : bannerimg}
              className="bi_icon"
              alt={altTag}
              width={361}
              height={513}
            />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default BannerSec2
